import React from 'react';
import { MenuItem, Checkbox, ListItemText } from '@material-ui/core';

export const getSelectDefaultProps = () => {
  return {
    displayEmpty: true,
    MenuProps: {
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
      },
    },
  };
};

export const getRenderedSelectMultipleValues = (
  selectValues,
  list,
  valueKey,
  labelKey
) => {
  let values = [];
  selectValues.map((value) => {
    const index = list
      .map(function (e) {
        return e[valueKey];
      })
      .indexOf(value);
    if (index > -1) {
      values.push(list[index][labelKey || 'nome']);
    }
    return value;
  });
  return values.join(', ');
};

export const getSelectMultipleItems = (
  selectedValues,
  list,
  valueKey,
  labelKey
) => {
  return list.map((listItem, index) => {
    return (
      <MenuItem value={listItem[valueKey]} key={index}>
        <Checkbox checked={selectedValues.indexOf(listItem[valueKey]) > -1} />
        <ListItemText primary={listItem[labelKey]} />
      </MenuItem>
    );
  });
};

export const getSelectItems = (list, valueKey, labelKey) => {
  return list.map((listItem, index) => {
    return (
      <MenuItem
        value={listItem[valueKey]}
        key={index}
        disabled={
          typeof listItem.disabled === 'boolean' && listItem.disabled === true
            ? true
            : false
        }
      >
        {listItem[labelKey]}
      </MenuItem>
    );
  });
};
